// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'; // 本地语言 - en
import 'element-ui/lib/theme-chalk/index.css';
import '../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';
import App from './App';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import {
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText
} from '@fortawesome/vue-fontawesome';
import router from './router';
import store from './store';
import '@/styles/style.scss';
import 'ag-grid-enterprise';
import {
    LicenseManager
} from 'ag-grid-enterprise';
import global_ from './Global';
import base from './base';
import './permission';

LicenseManager.setLicenseKey(
    'SHI_Singapore_Solutions_Pte._Ltd.__on_behalf_of_P_&_G_APAC_DP_GTM_Plan_Validation_Tool_3Devs30_January_2020__MTU4MDM0MjQwMDAwMA==a987f70c792cc9f7ffdefee9f0125a75'
);
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);
// element localization - en
Vue.use(ElementUI, { locale });
Vue.prototype.GLOBAL = global_; //global constant variable
Vue.use(base); //global methods
Vue.config.productionTip = false; //remove dev mode tips
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js